const images = require.context("./", true);
const AeroCapture = images("./" + "icons/AeroCapture.svg");
const AeroGCSE = images("./" + "icons/AeroGCSEnterprise.svg");

exports.services = [
    { id: "a606c8cf-0968-4bf9-87ca-2dacc3f18f3d", title: "PicStork", description: "Detect Objects and Generate Reports", redirecturl: "/aerocapture/dashboard", image: AeroCapture },
    { id: "70a37903-a4c0-4476-b1b4-ef115d0ac144", title: "AeroGCS Enterprise", description: "AeroGCS Enterprise Features", redirecturl: "/", image: AeroGCSE },
]